import { useEffect, ReactNode } from 'react'
import { toggleDocumentAttribute } from '../utils'
import WOW from 'wow.js'

import Preloader from './Preloader'
import NavigationBar from './NavigationBar'
import Footer from './Footer'

interface LayoutProps {
  children: ReactNode
}

const Layout = ({ children }: LayoutProps) => {
  useEffect(() => {
    // Check if jQuery is available before using it
    const initializeLayout = () => {
      if (typeof window !== 'undefined' && typeof window.$ === 'function') {
        const width = window.$(window).width()
        if (width && width > 767) {
          new WOW({
            boxClass: 'wow',
            animateClass: 'animated',
            offset: 0,
            mobile: false,
            live: true
          }).init()
        }
      } else {
        // Fallback if jQuery is not available
        if (window.innerWidth > 767) {
          new WOW({
            boxClass: 'wow',
            animateClass: 'animated',
            offset: 0,
            mobile: false,
            live: true
          }).init()
        }
      }

      toggleDocumentAttribute('data-offset', '100', 'body')
      toggleDocumentAttribute('data-spy', 'scroll', 'body')
      toggleDocumentAttribute('data-target', '.navbar', 'body')
    }

    // Initialize immediately if jQuery is available, otherwise wait for the event
    if (typeof window !== 'undefined' && typeof window.$ === 'function') {
      initializeLayout()
    } else {
      // Listen for jQuery ready event
      const handleJQueryReady = () => {
        initializeLayout()
      }
      
      window.addEventListener('jqueryReady', handleJQueryReady)
      
      // Fallback timeout
      const timer = setTimeout(() => {
        if (typeof window.$ === 'function') {
          initializeLayout()
        }
      }, 500)
      
      return () => {
        window.removeEventListener('jqueryReady', handleJQueryReady)
        clearTimeout(timer)
      }
    }

    return (() => {
      toggleDocumentAttribute('data-offset', '100', 'body', true)
      toggleDocumentAttribute('data-spy', 'scroll', 'body', true)
      toggleDocumentAttribute('data-target', '.navbar', 'body', true)
    })
  }, [])

  return (
    <>
      <Preloader />
      <NavigationBar />
      {children}
      <Footer />
    </>
  )
}

export default Layout
